import { render, staticRenderFns } from "./dog-purchase-view.vue?vue&type=template&id=396b5e98&scoped=true&lang=pug"
import script from "./dog-purchase-view.js?vue&type=script&lang=js&external"
export * from "./dog-purchase-view.js?vue&type=script&lang=js&external"
import style0 from "./dog-purchase-view.vue?vue&type=style&index=0&id=396b5e98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396b5e98",
  null
  
)

export default component.exports